<script setup>
import VueApexCharts from 'vue3-apexcharts'

defineProps({
    type: {
        type: String,
        default: 'bar',
    },
    height: {
        type: [Number, String],
        default: 350,
    },
    series: {
        type: Array,
        required: true,
    },
    options: {
        type: Object,
        required: true,
    },
})
</script>

<template>
    <VueApexCharts :type="type" :height="height" :series="series" :options="options" />
</template>
